const firstSecEl = document.querySelector('.first-sec');

if (firstSecEl) {
  const updateNextSecHeight = () => {
    const nextSection = firstSecEl.nextElementSibling;

    if (!nextSection || !nextSection.classList.contains('trusted-sec')) return;

    firstSecEl.style.setProperty(
        '--next-sec-h',
        `${nextSection.offsetHeight}px`
    );
    firstSecEl.classList.add('is-next-trusted-sec');
  };

  let resizeTimeout = null;

  window.addEventListener('resize', () => {
    if (resizeTimeout) return;

    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      updateNextSecHeight();
    }, 150);
  });

  updateNextSecHeight();
}
